import { TColors } from '@cian/ui-kit-design-tokens/colors';

import { TLabelColor, ELabelColor } from '../../types/label';

export const labelBgColorMap: Record<ELabelColor, TColors | string> = {
  [ELabelColor.Red]: 'surface-negative-default',
  [ELabelColor.Green]: 'surface-positive-default',
  [ELabelColor.DarkGreen]: 'accent-positive-primary',
  [ELabelColor.Blue]: 'accent-main-secondary',
  [ELabelColor.Gray]: 'overlay-control-default',
  [ELabelColor.Yellow]: 'surface-warning-default',
  [ELabelColor.OrangePercent]: 'brand-pink',
  [ELabelColor.SimpleBlue]: 'accent-main-secondary',
  [ELabelColor.SimpleBlueIconed]: 'accent-main-secondary',
  [ELabelColor.Purple]: 'decorative-lavender',
  [ELabelColor.DarkGray]: 'surface-neutral-default',
  [ELabelColor.BlueVerifiedByCian]: 'accent-main-secondary',
  [ELabelColor.BlueInstantBooking]: 'accent-main-secondary',
  [ELabelColor.Orange]: 'surface-warning-default',
  [ELabelColor.PurpleEarlyAccess]: 'decorative-lavender-transparent',
  [ELabelColor.BlueCpdLabel]: 'accent-main-secondary',
};

export const labelTextColorMap: Record<ELabelColor, TColors> = {
  [ELabelColor.Red]: 'accent-negative-primary',
  [ELabelColor.Green]: 'accent-positive-primary',
  [ELabelColor.DarkGreen]: 'theme-white',
  [ELabelColor.Blue]: 'accent-main-primary',
  [ELabelColor.Gray]: 'theme-dark',
  [ELabelColor.DarkGray]: 'theme-dark',
  [ELabelColor.Yellow]: 'accent-warning-primary',
  [ELabelColor.OrangePercent]: 'theme-dark',
  [ELabelColor.SimpleBlue]: 'accent-main-primary',
  [ELabelColor.SimpleBlueIconed]: 'accent-main-primary',
  [ELabelColor.Purple]: 'decorative-purple',
  [ELabelColor.BlueVerifiedByCian]: 'accent-main-primary',
  [ELabelColor.BlueInstantBooking]: 'accent-main-primary',
  [ELabelColor.Orange]: 'accent-warning-primary',
  [ELabelColor.PurpleEarlyAccess]: 'decorative-purple',
  [ELabelColor.BlueCpdLabel]: 'accent-main-primary',
};

export function mapLabelBgColor(color: TLabelColor, isDailyrent: boolean = false): TColors {
  if (isDailyrent) {
    switch (color) {
      case ELabelColor.Green:
        return 'surface-positive-default';
      default:
        return 'accent-ghost-secondary';
    }
  }

  return labelBgColorMap[color] as TColors;
}

export function mapLabelColor(color: TLabelColor, isDailyrent: boolean = false): TColors {
  if (isDailyrent) {
    switch (color) {
      case ELabelColor.Green:
        return 'accent-positive-primary';
      default:
        return 'text-primary-default';
    }
  }

  return labelTextColorMap[color];
}
